// @ts-nocheck
import "./Select.scss";

import { Component, h, render } from "preact";
import { useCallback, useMemo, useState } from "preact/hooks";

import cn from "classnames";

/**
 * @callback onChange
 * @param {string | number | null} value
 */

/**
 * @param {object} props Props
 * @param {{label: string, value: string}[]} props.options
 * @param {string | number | null} props.value
 * @param {onChange} props.onChange
 * @param {boolean} [props.disabled]
 * @return {JSX}
 */

function Select({ options, value, onChange, disabled, ...rest }) {
  const [isOpened, setIsOpened] = useState(false);

  const toggleOpened = useCallback(() => setIsOpened((o) => !o));

  const handleChange = useCallback(
    (value) => {
      onChange(value);
      toggleOpened();
    },
    [onChange]
  );

  const selectedValue = useMemo(
    () => options.find((o) => o.value === value) || options[0],
    [options, value]
  );

  const optionsMarkup = useMemo(() =>
    options.map(
      (option) => (
        <div
          className="CCSelect__options-item"
          onClick={() => handleChange(option.value)}
        >
          {option.label} {option.value === value && checkedIcon}
        </div>
      ),
      [options]
    )
  );

  return (
    <div
      className={cn("CCSelect t-text", isOpened && "CCSelect_opened")}
      {...rest}
    >
      <div className="CCSelect__value" onClick={toggleOpened}>
        {selectedValue.label} {openedIcon}
      </div>
      <div className="CCSelect__options">{optionsMarkup}</div>
    </div>
  );
}

const checkedIcon = (
  <svg
    className="CCSelect__options-checked"
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 4L4 7L10 1" stroke-width="2" stroke-linecap="round" />
  </svg>
);

const openedIcon = (
  <svg
    className="CCSelect__value-opened"
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.81088 4.8764C4.41175 5.42946 3.58825 5.42946 3.18911 4.8764L0.813897 1.58521C0.336598 0.923842 0.809174 2.38419e-07 1.62478 2.38419e-07L6.37522 2.38419e-07C7.19083 2.38419e-07 7.6634 0.923842 7.1861 1.58521L4.81088 4.8764Z" />
  </svg>
);

export default Select;
